module.exports = __webpack_public_path__ + "static/media/flowrate-diagram.9cfc09d3.jpg";